const constantsErrorMessageByCode = {
	"0004": {
		slug: "validation",
		uiMessage:
			"Senha inválida. Não utilize data de nascimento, senhas de banco ou sequências númericas (ex: 1, 2, 3).",
	},
	"0013": {
		slug: "blocked_password",
		uiMessage:
			"Você excedeu o número de tentativas de login. Para continuar, clique em 'Esqueci minha senha' e redefina sua senha.",
	},
} as { [key: string]: { slug: string; uiMessage: string } };

export default constantsErrorMessageByCode;
